import React from 'react'

import isPast from 'date-fns/isPast';
import eachMonthOfInterval from 'date-fns/eachMonthOfInterval';
import eachDayOfInterval from 'date-fns/eachDayOfInterval';
import eachWeekOfInterval from 'date-fns/eachWeekOfInterval';
import endOfMonth from 'date-fns/endOfMonth';
import endOfWeek from 'date-fns/endOfWeek';
import startOfMonth from 'date-fns/startOfMonth';
import startOfWeek from 'date-fns/startOfWeek';
import format from 'date-fns/format';
import addYears from 'date-fns/addYears';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';

import Month from './Month';

export default function Calandar({
    startDate = new Date(),
    endDate,
    selectedDates = [],
    onSelect,
    onChange,
    schedule,
    autoHeight
}) {

    // function eachWeekOfIntervalMonday(interval) {
    //     let weeks = eachWeekOfInterval(interval, { weekStartsOn: 1 });
      
    //     weeks = weeks.filter(weekStart => isSameMonth(weekStart, interval.start));
      
    //     return weeks;
    //   }

    let selectedDays = selectedDates?.sort((a, b) => a - b);
    const weekDays = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];
    const months = eachMonthOfInterval({
        start: startDate,
        end: endDate || addYears(new Date(), 1)
    });
    const dates = months.map((month) => {
        const weeks = eachWeekOfInterval({
            start: startOfMonth(month),
            end: endOfMonth(month)
        }, { weekStartsOn: 1 }).map((week) => {
            let weekStart = startOfWeek(week, { weekStartsOn: 1 });
            let weekEnd = endOfWeek(week, { weekStartsOn: 1 });
            if(weekStart.getMonth() !== month.getMonth()) {
                weekStart = month;
            }
            if(weekEnd.getMonth() !== month.getMonth()) {
                weekEnd = endOfMonth(month);
            }
            let days = eachDayOfInterval({
                start: weekStart,
                end: weekEnd
            }).map((day) => {
                return {
                    day: format(day, 'dd'),
                    date: day,
                    weekDay: (day.getDay() - 1 + 7) % 7,
                    isPast: isPast(day),
                    isSelected: selectedDays.some((selectedDay) => isSameDay(day, selectedDay)),
                    isCheckin: isSameDay(day, selectedDays[0]),
                    isCheckout: isSameDay(day, selectedDays[1]),
                    isIncluded: selectedDays[0] && selectedDays[1] && isBefore(day, selectedDays[1]) && isBefore(selectedDays[0], day)
                }
            });
            return {
                week: week,
                days
            }
        })
        return {
            month: month,
            weeks
        }
    });

    const hasSchedule = schedule?.length > 0;

    return (
        <div className="ola-calendar">
            {!autoHeight &&
                <div className="ola-weekdays flex sticky top-0 left-0 w-full py-2 px-4 bg-white border-b border-line">
                    {weekDays?.map((day) => {
                        return (
                            <div key={day} className="ola-weekday text-center text-xs text-gray uppercase" style={{width: 'calc(100% / 7)'}}>{day}</div>
                        )
                    })}
                </div>
            }

            <div className='relative box-border overflow-auto pb-10' style={!autoHeight ? {height: 'calc(100vh - 350px)'} : {}}>
                {dates?.map((date) => {
                    return (
                        <Month
                            key={date.month}
                            selectedDates={selectedDates}
                            onSelect={onSelect}
                            onChange={onChange}
                            schedule={schedule}
                            hasSchedule={hasSchedule}
                            date={date}
                        />
                    )
                })}
            </div>
        </div>
    )
}
